/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
import { advanceFrame, advanceMultipleFrames, setTotalFrameCount, setUniqueState, deactivateContents} from 'redux/actions/content_status';
import { fetchQuestionnaireData, clearContentsData } from 'redux/actions/content_data';
import { displayScreen } from 'redux/actions/screen_status';
import { excludeQuestionnaire } from 'redux/actions/session_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import QuestionnaireContent from 'components/content/questionnaire/questionnaire';
import { batchActions } from 'redux-batched-actions';



/* ========== ~~~~~~~~~~ QUESTIONNAIRE : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, contentData, sessionStatus, embedStatus, queueStatus, rewards }, { contentId }) => ({
    currentContentStatus: contentStatus[contentId],
    currentContentSettings: settings.contentSettings[contentId],
    currentContentData: contentData[contentId],
    onStartScreens: settings['contentSettings'][contentId]['uniqueProps']['onStartScreens'],
    onCompleteScreens: settings['contentSettings'][contentId]['uniqueProps']['onCompleteScreens'],
    showCoverScreens: settings['contentSettings'][contentId]['uniqueProps']['showCoverScreens'],
    questionnaireType: settings['contentSettings'][contentId]['uniqueProps']['questionnaireType'],
    targetCompletion: settings['contentSettings'][contentId]['uniqueProps']['questionnaireType'] === 'LIFESTYLE' ?
        settings['contentSettings'][contentId]['uniqueProps']['targetCompletion'] : null,
    questionnaires: contentData[contentId]['questionnaires'],
    excludedQuestionnaires: sessionStatus.excludedQuestionnaires,
    // enableABTest: settings.embedSettings.enableABTest,
    // abTestVersion: embedStatus.abTestVersion,
    sessionStatus,
    embedStatus,
    dataFetchingPermitted: sessionStatus.dataFetchingPermitted,
    dmpCallsEnabled: sessionStatus.dmpCallsEnabled,
    userId: sessionStatus.userInfo.userId !== undefined ? sessionStatus.userInfo.userId : null,
    rewardsEnabled: rewards.settings.enabled,
    rewardsPermitted: rewards.status.rewardsPermitted,
    isPubPortalPreview: settings.embedSettings.isPubPortalPreview
});

// map actions
const mapDispatchToProps = dispatch => ({
    advanceFrame: contentId => dispatch(advanceFrame(contentId)),
    setTotalFrameCount: (contentId, totalFrameCount) => dispatch(setTotalFrameCount(contentId, totalFrameCount)),
    setUniqueState: (contentId, uniqueState) => dispatch(setUniqueState(contentId, uniqueState)),
    setUniqueStateAndFrameCount: (contentId, uniqueState, totalFrameCount) =>
        dispatch(batchActions([
            setUniqueState(contentId, uniqueState),
            setTotalFrameCount(contentId, totalFrameCount)
        ])),
    // deactivateContents: contents => dispatch(deactivateContents(contents)),
    deactivateContents: contentIds =>
        dispatch(batchActions([
            deactivateContents(contentIds),
            clearContentsData(contentIds)
        ])),
    displayScreen: (screen) => dispatch(displayScreen(screen)),
    fetchQuestionnaireData: (questionnaireContentId, cookieId, uniqueProps, isPubPortalPreview) => dispatch(fetchQuestionnaireData(questionnaireContentId, cookieId, uniqueProps, isPubPortalPreview)),
    excludeQuestionnaire: (questionnaire) => dispatch(excludeQuestionnaire(questionnaire)),
    advanceMultipleFrames: (contentId, numOfFrames) => dispatch(advanceMultipleFrames(contentId, numOfFrames))
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuestionnaireContent);
